import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import AppContainer from './appContainer'
import GroupCallContainer from "./components/shares/call_screen/groupcall/rxGroupCallScreen"
import CallContainer from "./components/shares/call_screen/call/rxCallScreen"
import JoinGroupCall from "./components/shares/call_screen/groupcall/rxJoinGroupCall"
import Clock from "./clock"

class ViewManager extends Component {
  static Views() {
    return {
      app: <AppContainer/>,
      groupcall: <GroupCallContainer />,
      call: <CallContainer />,
      join_meet: <><AppContainer/><JoinGroupCall /></>
    }
  }

  static View(props) {
    try {
      let name = props.location.search.substr(1)
      let view = ViewManager.Views()[name]
      if (name && view) {
        return ViewManager.Views()[name]
      } else if (name.indexOf('join_meet') !== -1) {
        return ViewManager.Views()['join_meet']
      } else {
        return ViewManager.Views()['app']
      }
    } catch(e) {
      return ViewManager.Views()['app']
    }
  }

  render() {
    return (
      <Router>
        <div>
          <Clock />
          <Route path='/' component={ViewManager.View}/>
        </div>
      </Router>
    )
  }
}
export default ViewManager